import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'core/components/button/button.module';

import { DateInputComponent } from './date-input/date-input.component';
import { DatepickerComponent } from './datepicker/datepicker.component';

@NgModule({
  declarations: [DatepickerComponent, DateInputComponent],
  exports: [DatepickerComponent, DateInputComponent],
  imports: [CommonModule, OverlayModule, ButtonModule, ReactiveFormsModule],
})
export class DateInputModule {}
